import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import '../../assets/css/topNav.css';
import { useUser } from '../../utils/hooks/user';
import { useDispatch } from 'react-redux';
import { useRootMemoSelector } from 'use-redux-states';
import { logoutUser } from '../../store/auth';
import Broadcasts, { CreateBroadcast } from '../Broadcasts';
import LanguageSelector from './LanguageSelector';

import {
  GiftOutlined,
  LogoutOutlined,
  QuestionCircleOutlined,
  UserOutlined,
  DownOutlined
} from '@ant-design/icons';
import { message, Layout, Dropdown, Avatar } from 'antd';
import Language from '../../utils/Language';

const { Header: AntHeader } = Layout;
const source_url = window.location.href;

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [ip, setIp] = useState('');

  const companyData = useRootMemoSelector('app.company');
  const { profile_picture, meta } = useUser();

  const handleLogout = async () => {
    try {
      await api.post('/logout', { source_url, ip });
    } catch (error) {
      message.error('Something went wrong', 5);
    }
    dispatch(logoutUser());
    navigate('/auth/login');
  };

  useEffect(() => {
    // Check if IP is already fetched
    if (!ip) {
      axios
        .get('https://ipapi.co/json/')
        .then((data) => {
          const { ip: fetchedIp } = data.data;
          setIp(fetchedIp);
        })
        .catch((error) => console.log('error => ', error));
    }
  }, []);

  useEffect(() => {
    companyData?.id &&
      Language.loadGoogleTranslate({ language: meta?.language || companyData?.options?.language });
  }, [companyData?.options?.language, companyData?.id, meta?.language]);

  return (
    <AntHeader className='fixed py-6 w-full h-16 z-50 bg-white shadow-sm'>
      <div className='fixed top-0 right-0 h-16 px-6 flex items-center gap-6'>
        <LanguageSelector className='hidden md:flex' />
        <span title='Help Center' className='hidden md:inline-flex cursor-pointer'>
          <QuestionCircleOutlined
            style={{ fontSize: '18px' }}
            onClick={() => window.open('https://sawport.freshdesk.com/support/home')}
            id='help'
          />
        </span>
        <span title='Broadcast' className='hidden md:inline-flex cursor-pointer'>
          <CreateBroadcast />
        </span>
        <span title='Notifications' className='hidden md:inline-flex cursor-pointer'>
          <Broadcasts />
        </span>
        <span title='Updates' className='hidden md:inline-flex cursor-pointer'>
          <GiftOutlined
            style={{ fontSize: '18px' }}
            onClick={() =>
              window.open('https://sawport.freshdesk.com/support/solutions/folders/150000082898')
            }
            id='updates'
          />
        </span>
        <div className='profileIcon'>
          <Dropdown
            menu={{
              items: [
                {
                  key: 'language-mobile',
                  icon: <LanguageSelector className='md:hidden w-full' />,
                  label: '',
                  className: 'md:hidden p-0'
                },
                {
                  key: 'profile',
                  icon: <UserOutlined />,
                  label: 'Profile',
                  onClick: () => navigate('/profile')
                },
                {
                  key: 'logout',
                  icon: <LogoutOutlined />,
                  label: 'Logout',
                  onClick: handleLogout
                }
              ]
            }}
            trigger={['click']}>
            <a onClick={(e) => e.preventDefault()} className='flex items-center cursor-pointer'>
              <Avatar src={profile_picture} size='default' style={{ marginRight: '8px' }} />
              <DownOutlined />
            </a>
          </Dropdown>
        </div>
      </div>
    </AntHeader>
  );
};

export default Header;
